import React, { useState } from "react";
import { Popconfirm } from "antd";

import { PopconfirmProps } from "antd/lib/popconfirm";

interface Props extends PopconfirmProps {
  disabled: boolean;
  onConfirm: NonNullable<PopconfirmProps["onConfirm"]>;
}

const VariablePopconfirm = ({ disabled, children, onConfirm, ...props }: Props) => {
  const [visible, setVisible] = useState(false);

  const handleConfirm = () => {
    setVisible(false);
    onConfirm();
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const handleVisibleChange = (visible: boolean) => {
    if (!visible) {
      setVisible(visible);
      return;
    }
    if (disabled) {
      handleConfirm();
    } else {
      setVisible(visible);
    }
  };

  return (
    <Popconfirm
      visible={visible}
      onVisibleChange={handleVisibleChange}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
      {...props}
    >
      {children}
    </Popconfirm>
  );
};

export default VariablePopconfirm;
